import styled from "styled-components";

export const ButtonContainer = styled.button`
  cursor: pointer;
  font-size: 1rem;
  min-height: 3rem;
  height: fit-content;

  font-weight: var(--bn-results-btn-fw);
  color: var(--bn-results-btn-color);
  background-color: var(--bn-results-btn-bg-color);
  border: var(--bn-results-btn-border);
`;
